import { motion } from "framer-motion";
import Navigation from "../../components/Navigation";
import PageHero from "../../components/PageHero";

// Animation constants
const FADE_IN_UP = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6 }
};

// English Class Page
const EnglishClassPage = () => {
  return (
    <div data-testid="english-class-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets.emergentagent.com/job_4bb091c1-e4be-474e-9067-19b51e555ba6/artifacts/kq9arin8_class.jpg"
        alt="English Class at Murphy's Giving Market"
      />

      {/* Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={FADE_IN_UP.initial}
            animate={FADE_IN_UP.animate}
            transition={FADE_IN_UP.transition}
          >
            <h1 
              data-testid="english-class-title"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-8"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              English Class
            </h1>
            
            <div className="space-y-6">
              {/* English description */}
              <p className="text-[#1A1A1A] text-base md:text-lg leading-relaxed">
                Murphy's Giving Market offers English classes in the spring, summer, and fall. Call or text <a href="tel:484-257-9794" className="text-[#1877F2] hover:underline font-medium whitespace-nowrap">484-257-9794</a> for information.
              </p>
              
              {/* Spanish description */}
              <p className="text-[#1A1A1A] text-base md:text-lg leading-relaxed italic">
                Murphy's Giving Market ofrece clases de inglés en primavera, verano y otoño. Llame o envíe un texto al <a href="tel:484-257-9794" className="text-[#1877F2] hover:underline font-medium whitespace-nowrap">484-257-9794</a> para información.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default EnglishClassPage;
